import BusinessHours from './businessHours';

export default BusinessHours;